import React, { useState } from 'react';
import { formatDateDistance } from '@magalu/stereo-ui-utils';
import { shape, string, arrayOf, number } from 'prop-types';
import Box from '@magalu/stereo-ui/atoms/Box';
import Avatar from '@magalu/stereo-ui/molecules/Avatar';
import MediaReviewCard from '@magalu/stereo-ui/molecules/MediaReviewCard';
import Review from '@magalu/stereo-ui/molecules/Review';
import { ProductReviewGallery, ProductReviewPopup } from '../index';
import { formatMediaList } from './helpers';
import { Header, ReviewerName, Description, SeeMore, SubTitle, ReviewWrapper, DateWrapper } from './opinion-snippet-block.styles';

const renderGallery = (mediasList, openPopup) => {
  return mediasList.map(elem => /*#__PURE__*/React.createElement(MediaReviewCard, {
    key: `gallery-media-${elem.mediaUrl}`,
    media: elem,
    onClick: () => openPopup(elem.mediaUrl.split('/').reverse()[0]),
    width: "124px",
    height: "124px"
  }));
};

const OpinionSnippetBlock = ({
  review,
  charLimit
}) => {
  const [seeMore, setSeeMore] = useState(false);
  const {
    rating,
    description,
    submissionDate,
    attributes,
    userData,
    product
  } = review;
  const isShortDescription = (description == null ? void 0 : description.length) <= charLimit;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(0);
  /**
   * check if it has only digits - in case to be a timestamp
   */

  const isTimestamp = /^\d+$/.test(submissionDate);
  const days = submissionDate && !isTimestamp && formatDateDistance(new Date(submissionDate), new Date());
  const subtitle = (attributes == null ? void 0 : attributes.map((el, index) => index === 0 ? `${el.label}: ${el.value}` : ` | ${el.label}: ${el.value}`)) || [];
  const arrayImages = formatMediaList(product == null ? void 0 : product.images, 'image');
  const arrayVideos = formatMediaList(product == null ? void 0 : product.videos, 'video');
  const processedMedias = arrayImages.filter(elem => elem.processed).concat(arrayVideos.filter(elem => elem.processed));
  const thumbnailsMedias = arrayImages.filter(elem => elem.thumbnails).concat(arrayVideos.filter(elem => elem.thumbnails));

  const openPopup = name => {
    const mediaId = processedMedias.findIndex(elem => elem.mediaUrl.includes(name.split('.')[0]));
    setSelectedMedia(mediaId > 0 ? mediaId : 0);
    setIsPopupOpen(true);
  };

  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Avatar, null), /*#__PURE__*/React.createElement(ReviewerName, null, userData == null ? void 0 : userData.name), /*#__PURE__*/React.createElement(ReviewWrapper, null, /*#__PURE__*/React.createElement(Review, {
    score: rating
  }))), subtitle.length > 0 && /*#__PURE__*/React.createElement(SubTitle, {
    "data-testid": "review-sub-title"
  }, subtitle), description && /*#__PURE__*/React.createElement(Description, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : `${description.substring(0, charLimit)}...`, "\xA0", !isShortDescription && /*#__PURE__*/React.createElement(SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    "data-testid": "see-more-btn",
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos')), days && /*#__PURE__*/React.createElement(DateWrapper, {
    "data-testid": "review-date"
  }, `há ${days}`), thumbnailsMedias.length > 0 && /*#__PURE__*/React.createElement(ProductReviewGallery, null, renderGallery(thumbnailsMedias, openPopup)), isPopupOpen && /*#__PURE__*/React.createElement(ProductReviewPopup, {
    review: review,
    charLimit: charLimit,
    mediaProps: arrayImages.concat(arrayVideos),
    selectedMedia: selectedMedia,
    closePopup: () => setIsPopupOpen(false)
  }));
};

process.env.NODE_ENV !== "production" ? OpinionSnippetBlock.propTypes = {
  review: shape({
    rating: number,
    description: string,
    submissionDate: string,
    dimensionDefs: arrayOf(string),
    userData: shape({
      name: string
    })
  }),
  charLimit: number,
  mediaReview: shape({
    images: arrayOf(string),
    video: arrayOf(string)
  })
} : void 0;
OpinionSnippetBlock.defaultProps = {
  charLimit: 110,
  mediaReview: null
};
export default OpinionSnippetBlock;